import { atom } from "recoil";

export const badgesAddModalStore = atom({
	key: "badgesAddModalStore",
	default: {
		show: false,
		loaded: true,
		id: 0,
		name: "",
		text_color: "#FFFFFF",
		background_color: "#FF4D4F",
		currentOption: {
			status: [{ value: "active", label: "Active" }, { value: "inactive", label: "Inactive" }],
		},
		status: { value: "active", label: "Active" },
		date: new Date(),
	},
});
